<div class="row plain-styled-form">
    <div class="col-12 col-md-4 mb-3">
        <dx-text-box label="First Name" stylingMode="filled" [(value)]="data.firstName">
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="col-12 col-md-4 mb-3">
        <dx-text-box label="Middle Name" stylingMode="filled" [(value)]="data.middleName"></dx-text-box>
    </div>
    <div class="col-12 col-md-4 mb-3">
        <dx-text-box label="Last Name" stylingMode="filled" [(value)]="data.lastName">
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>

    <div class="col-12 col-md-7 mb-3">
        <dx-text-box label="Email" stylingMode="filled" [(value)]="data.email">
            <dxi-button name="icon" location="before" [options]="{ icon: 'email', stylingMode: 'text' }"></dxi-button>
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
                <dxi-validation-rule type="email"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="col-12 col-md-5 mb-3">
        <dx-text-box label="Phone" stylingMode="filled" mask="(000) 000-0000" [(value)]="data.phone">
            <dxi-button name="icon" location="before" [options]="{ icon: 'tel', stylingMode: 'text' }"></dxi-button>
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="col-12 mb-3">
        <dx-text-box label="Address" stylingMode="filled" [(value)]="data.address">
            <dxi-button name="icon" location="before" [options]="{ icon: 'home', stylingMode: 'text' }"></dxi-button>
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>

    <div class="col-12 mb-3">
        <dx-tag-box
            label="User role(s)"
            stylingMode="filled"
            valueChangeEvent="input"
            [dataSource]="rolesDataSource"
            displayExpr="name"
            valueExpr="name"
            [showClearButton]="true"
            [searchEnabled]="true"
            [(value)]="data.roles"
        >
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-tag-box>
    </div>
    @if (isSupplierSelected && showSupplierFields) {
        <div class="col-12 mb-3">
            <dx-tag-box
                label="Supplier"
                stylingMode="filled"
                [dataSource]="supplierDataSource"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.supplierIds"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Supplier is required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </div>
    }
    @if (isCarrierSelected && showCarrierFields) {
        <div class="col-12 mb-3">
            <dx-tag-box
                label="Carrier"
                stylingMode="filled"
                [dataSource]="carrierDataSource"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.carrierIds"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Carrier is required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </div>
    }
    @if (isVendorSelected && showVendorFields) {
        <div class="col-12 mb-3">
            <dx-tag-box
                label="Vendor"
                stylingMode="filled"
                [dataSource]="vendorDataSource"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.vendorIds"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Vendor is required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </div>
    }
    @if (isCustomerSelected && showCustomerFields) {
        <div class="col-12 mb-3">
            <dx-tag-box
                label="Customer ID(s)"
                stylingMode="filled"
                [dataSource]="customerDataSource"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.customerIds"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Customer is required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </div>
    }
    @if (isFinanceSelected && showSiteFields) {
        <div class="col-12 mb-3">
            <dx-tag-box
                label="Site"
                stylingMode="filled"
                [dataSource]="siteDataSource"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.siteIds"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Site is required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </div>
    }
    @if (isAgencySelected && showAgencyFields) {
        <div class="col-12 mb-3">
            <dx-tag-box
                label="Agency ID(s)"
                stylingMode="filled"
                [dataSource]="agencyDataSource"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.agencyIds"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Agency ID is required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </div>
    }
    @if (showShiftField) {
        <div class="col-12 mb-3">
            <dx-select-box
                label="Shift"
                stylingMode='filled'
                [dataSource]="shiftDataSource"
                displayExpr='name'
                valueExpr='id'
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.shiftId"
            >
            </dx-select-box>
        </div>
    }
</div>
